module.exports = __webpack_public_path__ + "img/image-slider-01.05ed52be.jpg";